import useApiMutation from '_api/mutations/useApiMutation';
import { NewPresignedUrl, PresignedUrl } from '_api/types';

export const CREATE_FILE_URL_KEY = 'create-file-url-key';

export const useCreateFileUrl = () =>
  useApiMutation<PresignedUrl, NewPresignedUrl>(
    () => '/file/new-url',
    'post',
    {},
    {
      mutationKey: [CREATE_FILE_URL_KEY],
    },
    (body: NewPresignedUrl) => body,
  );
